import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import HomePage from './HomePage.jsx';

/**
 * Renders the home page at `/`, BUT first preserves backwards compatibility
 * with the old URL scheme:
 *
 *   /?tab=travel&map=usa     →  /travel-maps?map=usa
 *   /?map=usa                →  /travel-maps?map=usa
 *   /?category=states&...    →  /photo-shaper?category=states&...
 *   /?shape=california       →  /photo-shaper?shape=california
 *   /                        →  HomePage (no redirect)
 *
 * Old marketing links, sitemap entries, and shared URLs keep working.
 */
const LegacyRedirect = () => {
    const [params] = useSearchParams();

    const tab = params.get('tab');
    const map = params.get('map');
    const category = params.get('category');
    const shape = params.get('shape');

    if (tab === 'travel' || map) {
        const next = new URLSearchParams();
        if (map) next.set('map', map);
        const qs = next.toString();
        return <Navigate to={`/travel-maps${qs ? `?${qs}` : ''}`} replace />;
    }

    if (category || shape) {
        const next = new URLSearchParams();
        if (category) next.set('category', category);
        if (shape) next.set('shape', shape);
        const qs = next.toString();
        return <Navigate to={`/photo-shaper${qs ? `?${qs}` : ''}`} replace />;
    }

    return <HomePage />;
};

export default LegacyRedirect;
